<template>
    <div class="create-patient">
        <adcetris-logo />
        <patient-info />
        <div class="stage-container">

           <div class="patient-image">
                <!-- <img class="incognito" src="../../assets/images/doctor/incognito.png" v-if="!$store.state.patient.image || $store.state.currentRoute === '/create-patient/stage/1'"> -->
                <picture v-if="!$store.state.patient.image || $store.state.currentRoute === '/create-patient/stage/1'">
                    <source class="incognito" srcset="../../assets/images/doctor/incognito.webp" type="image/webp">
                    <source class="incognito" srcset="../../assets/images/doctor/incognito.png" type="image/png"> 
                    <img class="incognito" src="../../assets/images/doctor/incognito.png" alt="no select patient image">
                </picture>
                <picture class="image" v-else>
                    <source class="image" :srcset="`${publicPath}` + getWebPExe($store.state.patient.image)" type="image/webp">
                    <source class="image" :srcset="`${publicPath}` + $store.state.patient.image" type="image/jpeg"> 
                    <img class="image" :src="`${publicPath}` + $store.state.patient.image" alt="patient image">
                </picture>
                <!-- <img class="image" :src="`${publicPath}` + $store.state.patient.image" v-else> -->
           </div>

           <div class="mobile-header">
               <div class="patient-image">
                   <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="incognito" v-if="!$store.state.patient.image || $store.state.currentRoute === '/create-patient/stage/1'">
                        <circle cx="20" cy="20" r="20" fill="#F1F4F5"/>
                        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
                        <circle cx="20" cy="20" r="20" fill="#C4C4C4"/>
                        </mask>
                        <g mask="url(#mask0)">
                        <g opacity="0.8" filter="url(#filter0_f)">
                        <path d="M-6.25187 151.129C-4.08552 150.268 -0.78236 147.244 0.290092 146.047C1.92022 144.178 1.2124 144.346 2.99268 141.595L2.79963 139.411C2.79963 139.411 2.15616 137.941 2.69239 136.387C3.22861 134.812 3.91499 132.732 3.55035 130.737C3.18572 128.742 3.40021 125.361 3.67905 122.799C3.95788 120.237 4.57991 115.805 4.96599 114.251C5.33062 112.697 4.68715 109.211 5.43787 106.292C6.21003 103.352 6.01699 97.4715 6.55322 92.2002C7.11089 86.929 8.67668 79.7046 8.67668 79.7046C8.67668 79.7046 7.64712 79.7886 7.0251 78.5075C6.38163 77.2055 5.41642 74.0973 4.77295 72.7952C4.12947 71.4932 0.375889 64.3318 0.375889 64.3318C0.375889 64.3318 -0.889606 62.2107 -1.08265 59.0605C-1.16845 57.8844 -0.868156 53.9782 -1.29714 51.1431C-1.72612 48.3079 -1.61888 38.1854 -1.147 35.9383C-0.653667 33.7122 0.526031 30.793 3.31441 29.3649C6.10279 27.9369 8.99841 27.5588 10.1138 26.6138C10.7787 26.0468 13.5671 25.5007 14.9184 23.7576C15.0685 23.4636 15.1972 23.0436 15.1972 22.5186C15.1972 21.4055 14.9827 19.5994 14.9827 19.5994C14.9827 19.5994 13.9602 19.3256 12.9769 19.005C11.9936 18.2997 11.8503 18.3163 11.5347 17.0813C10.2237 11.9514 13.0497 9.00811 13.4357 8.16806C13.976 6.99249 16.2003 5.19493 17.3207 4.68863C17.6209 4.56262 19.1867 4.01659 19.7015 4.01659C20.2163 4.01659 22.6829 3.93259 23.3478 4.1426C24.0342 4.35261 26.7797 5.19266 27.3803 5.78069C27.9808 6.38972 29.2034 8.17481 29.3321 8.65784C29.4608 9.14086 29.2034 11.094 29.0747 11.829C28.946 12.543 28.8174 13.4671 28.6029 13.9501C28.3884 14.4331 28.0881 14.8742 28.0881 15.2312C28.0881 15.5882 28.0023 17.2683 27.7449 18.5074C27.5304 19.7464 27.1443 20.7755 26.8869 21.8255C26.6295 22.8756 26.3722 23.3376 25.6643 23.9046C24.9351 24.4717 24.1844 24.4717 24.0986 24.8707C24.0557 25.0387 23.9913 25.3117 23.9484 25.6477C25.0209 26.1728 28.4742 28.3569 29.2892 28.6719C30.3617 29.0919 34.5014 29.869 35.1234 30.541C36.2816 31.7801 37.4184 34.4472 39.3703 38.8154C41.3222 43.2047 42.845 52.3401 42.9737 53.6842C43.1024 55.0283 42.7163 58.4305 42.7163 58.4305C42.7163 58.4305 42.2016 59.7325 42.0729 60.0896C41.5152 61.8116 41.4294 62.9877 40.0567 63.0927C38.6839 63.1977 36.1744 63.2397 36.1744 63.2397L34.8445 62.6517C34.8445 62.6517 35.8526 70.6531 36.968 74.0973C38.0833 77.5415 37.3541 79.2846 36.9894 83.5058C36.6677 87.223 36.2602 90.0371 36.1315 91.6962C35.917 92.5573 35.6167 93.7963 35.2306 94.8674C34.5443 96.7785 34.4156 102.869 34.6086 105.053C34.8016 107.237 34.5014 111.479 34.3941 114.02C34.2869 116.562 34.5872 121.77 33.7721 124.206C32.957 126.642 32.764 128.175 32.9785 130.527C33.193 132.879 33.4075 135.211 32.6782 136.618C31.9489 138.025 29.4823 139.264 29.5681 140.272C29.6539 141.28 30.1043 142.414 29.2463 142.498C28.3884 142.582 29.2463 142.96 29.375 144.472C29.5681 146.635 30.5976 148.462 31.0266 149.659C31.4985 150.961 33.3646 156.044 31.0266 156.611C28.3669 157.241 25.6214 156.989 23.7125 156.674C23.3049 156.611 22.5757 156.254 23.1548 152.767C23.1548 152.767 21.2029 151.822 20.9241 150.709C20.6024 149.47 22.2539 145.522 21.9965 144.535C21.7392 143.548 22.7902 143.233 22.64 141.721C22.5113 140.209 22.9832 139.831 22.7687 139.348C22.5542 138.865 21.4603 138.277 22.3612 136.849C23.262 135.421 22.8545 134.79 23.6052 131.682C24.3559 128.574 24.742 119.607 25.0423 117.381C25.364 115.154 24.6133 112.697 24.6133 110.849C24.6133 109.001 23.7339 106.88 24.1415 103.814C24.549 100.748 23.8626 96.9255 23.691 95.0774C23.5194 93.2293 22.9832 88.2014 22.3612 88.9364C21.7392 89.6715 19.9589 93.8803 18.865 97.0305C17.7711 100.16 16.2482 106.04 15.7978 108.602C15.3473 111.164 15.4546 114.209 14.661 114.944C13.8673 115.679 14.1676 117.003 14.2534 118.011C14.3392 119.019 13.8245 120.741 13.803 124.29C13.7816 127.839 12.9236 133.467 12.7091 135.022C12.4946 136.555 10.9503 136.534 11.4436 138.172C11.9369 139.81 12.1943 140.272 11.5937 141.49C11.079 142.519 10.3712 144.031 10.3712 144.031C10.3712 144.031 11.079 146.026 11.1004 148.084C11.1219 150.394 11.3149 151.906 10.6714 152.788C10.3068 153.271 8.44074 153.355 5.9312 153.271C5.50222 153.25 4.53701 153.103 3.85064 153.061C2.71384 152.998 1.64138 155.099 -1.0183 155.582C-2.198 155.792 -7.77476 156.149 -7.90345 154.805C-8.0107 153.439 -8.39678 151.99 -6.25187 151.129ZM8.97697 60.4466C8.97697 60.4466 8.18335 55.3853 8.18335 53.9362C8.18335 52.4872 7.88306 49.358 7.88306 48.0769C7.88306 46.8169 6.70336 52.8022 6.70336 54.7973C6.70336 56.7924 7.79726 58.8925 7.79726 60.1526C7.79726 61.4126 8.99841 65.9909 8.99841 65.9909L8.97697 60.4466Z" fill="url(#paint0_linear)"/>
                        </g>
                        </g>
                        <defs>
                        <filter id="filter0_f" x="-10" y="2" width="55" height="157" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur"/>
                        </filter>
                        <linearGradient id="paint0_linear" x1="13.3702" y1="157" x2="17.3848" y2="-0.429173" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#010101"/>
                        <stop offset="1" stop-color="#010101" stop-opacity="0.2"/>
                        </linearGradient>
                        </defs>
                    </svg>
                    <img class="image" :src="`${publicPath}` + $store.state.patient.shortImage" v-else>
                </div>
                <div class="logo">
                    <img src="../../assets/images/moderator/takeda-logo.png">
                </div>
                <div class="questions" @click="$router.push('/help')">
                    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 25.0013C16.6043 25.0013 17.0942 24.5114 17.0942 23.9071C17.0942 23.3028 16.6043 22.8129 16 22.8129C15.3957 22.8129 14.9058 23.3028 14.9058 23.9071C14.9058 24.5114 15.3957 25.0013 16 25.0013Z" fill="white"/>
                        <path d="M16 0C7.17419 0 0 7.17419 0 16C0 24.8258 7.17419 32 16 32C24.8258 32 32 24.8258 32 16C32 7.17419 24.8258 0 16 0ZM16 30.4516C8.03097 30.4516 1.54839 23.969 1.54839 16C1.54839 8.03097 8.03097 1.54839 16 1.54839C23.969 1.54839 30.4516 8.03097 30.4516 16C30.4516 23.969 23.969 30.4516 16 30.4516Z" fill="white"/>
                        <path d="M20.6452 12.9342C20.6452 10.3742 18.56 8.28903 16 8.28903C13.44 8.28903 11.3548 10.3742 11.3548 12.9342C11.3548 13.3574 11.7058 13.7084 12.129 13.7084C12.5522 13.7084 12.9032 13.3574 12.9032 12.9342C12.9032 11.231 14.2968 9.83742 16 9.83742C17.7032 9.83742 19.0968 11.231 19.0968 12.9342C19.0968 14.6374 17.7032 16.031 16 16.031C15.5768 16.031 15.2258 16.3819 15.2258 16.8052V20.0361C15.2258 20.4594 15.5768 20.8103 16 20.8103C16.4232 20.8103 16.7742 20.4594 16.7742 20.0361V17.5381L17.1664 17.4348C19.2103 16.9084 20.6452 15.0503 20.6452 12.9342Z" fill="white"/>
                    </svg>
                </div>
           </div>

           <router-view />
        </div>
       <progress-bar />
    </div>
</template>

<script>
import PatientInfo from '../../components/Doctor/PatientInfo';
import ProgressBar from '../../components/Doctor/ProgressBar';
import AdcetrisLogo from '../../components/Doctor/AdcetrisLogo';
import { mapGetters } from 'vuex';

export default {
    components : {
        'patient-info' : PatientInfo,
        'progress-bar' : ProgressBar,
        'adcetris-logo' : AdcetrisLogo
    },
    data : () => ({
        publicPath: process.env.BASE_URL
    }),
    computed : {
        ...mapGetters([
            'getCurrentRouteIndex'
        ])
    },
    mounted(){
        document.addEventListener('backbutton', this.goBack, false)
    },
    beforeDestroy(){
        document.removeEventListener('backbutton', this.goBack);
    },
    methods : {
        goBack(){
            this.$store.commit('prevStage');
        },
        getWebPExe(str){
            return str.slice(0, -3) + 'webp';            
        }
    }
}
</script>

<style lang="scss">
.create-patient{
    width: 100%;
    height: 100%;

    background: url("../../assets/images/doctor/bg-doctor.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% auto;

    display: flex;

    .stage-container{
        padding-top: 5%;
        padding-bottom: 10.5%;
        padding-left: 4%;
        padding-right: 5%;
        width: 100%;

        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .mobile-header{
            display: none;
        }

        .patient-image{
            .incognito{                
                height: 648px;
                width: auto;
            }

            .image{
                height: 648px;
                width: auto;
            }

            color: #ffffff;
            font-size: 50px;
        }
    }
}

.webp{
    .create-patient{
        background: url("../../assets/images/doctor/bg-doctor.webp");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .create-patient{
        .stage-container{
            .patient-image{
                .incognito{                
                    height: 80vh;
                    width: auto;
                }

                .image{
                    height: 80vh;
                    width: auto;
                }
            }
        }
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 21/9) {
    .create-patient{
        .stage-container{
            padding: 3% 5% 5% 4%;

            .patient-image{
                .incognito{                
                    height: 85vh;
                }

                .image{
                    height: 85vh;
                }
            }
        }
    }
}

@media (max-width: 599px){
    .webp{
        .create-patient{
            background: url("../../assets/images/doctor/bg-doctor-mobile.webp");
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }
    }

    .create-patient{
        background: url("../../assets/images/doctor/bg-doctor-mobile.png");
        background-size: cover;

        .adcetris-logo{
            display: none;
        }

        .stage-container{
            padding-top: 3.333vw;
            padding-bottom: 18.333vw;
            padding-left: 2.778vw;
            padding-right: 2.778vw;

            flex-wrap: wrap;

            width: calc(100% - 2.778vw - 2.778vw - 10.833vw);

            .patient-image{
                display: none;
            }

            .mobile-header{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                width: 100%;

                .patient-image{
                    display: block;

                    svg,img{
                        width: 11.111vw;
                        height: auto;
                    }

                    img{
                        background: #ffffff;
                        border-radius: 50%;
                    }
                }

                .logo{
                    img{
                        width: 22vw;
                        height: auto;
                    }
                }

                .questions{
                    svg{
                        width: 8.889vw;
                        height: auto;
                    }
                }
            }
        }
    }
}
</style>